module.exports = __webpack_public_path__ + "static/moonamar-konopljino-ulje-iz-organskog-bio-sjemena-b1e7967d8e44198140f57cb87fd461db.png";